/**
 * Created by jerrie.yang on 2017-03-30.
 */
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { NotificationModel } from '@nw/ui-core-shared/domains/Notification';
import { MessageService } from '@nw/ui-core-shared/services/message.service';
import { SessionService } from '@nw/ui-core-shared/services/session.service';
import { IotAccessService } from '@nw/ui-core-shared/services/iot-access.service';

import { WatchlistIotActions } from '../../store/actions/WatchlistIotActions';
import { WatchlistApplicationState } from '../../store/watchlist-state';
import {IotEvent} from '../domain';

@Injectable()
export class IotHandlerService {

    newNotification: NotificationModel = {
        type   : '',
        message: '',
        title  : ''
    };

    constructor(private iotAccessService: IotAccessService,
                private messageService: MessageService,
                private sessionService: SessionService,
                private store: Store<WatchlistApplicationState>,
                private watchlistIotActions: WatchlistIotActions) {

        // TODO: figure out a way to allow user to add handler! DI maybe? EG: adding the callbacks in the handler

    }

    initIotHandler() {
        /* istanbul ignore next */
        this.iotAccessService.handlers['REMOVE_VEHICLE'] = (payload) => {
            this.newNotification.type = this.messageService.notificationTypes.INFO;
            this.newNotification.message = 'Vehicle is removed successfully.';

            this.iotAccessService.emitter.next(this.newNotification);
        };

        /* istanbul ignore next */
        this.iotAccessService.handlers['addNote'] = (payload) => {
            this.newNotification.type = this.messageService.notificationTypes.INFO;
            this.newNotification.message = 'Note is added successfully.';

            this.iotAccessService.emitter.next(this.newNotification);
        };

        /* istanbul ignore next */
        this.iotAccessService.handlers['removeNote'] = (payload) => {
            this.newNotification.type = this.messageService.notificationTypes.INFO;
            this.newNotification.message = 'Note is removed successfully.';
            this.iotAccessService.emitter.next(this.newNotification);
        };

        /* istanbul ignore next */
        this.iotAccessService.handlers['updateNote'] = (payload) => {
            this.newNotification.type = this.messageService.notificationTypes.INFO;
            this.newNotification.message = 'Note is updated successfully.';
            this.iotAccessService.emitter.next(this.newNotification);
        };

        this.iotAccessService.handlers[`session/${this.sessionService.getPrincipal().getUserId()}`] = (payload) => {

            const data:IotEvent = JSON.parse(payload);

            try {
                switch (data.event) {
                    case 'bid':
                        this.store.dispatch(this.watchlistIotActions.bidInfoUpdated(data.body));
                        break;

                    case 'vehicleUpdatedEvent':
                        this.store.dispatch(this.watchlistIotActions.vehicleUpdated(data.body));
                        break;

                    case 'vehicleRemovedEvent':
                        this.store.dispatch(this.watchlistIotActions.vehicleRemoved(data.body));
                        break;

                    default:
                        this.newNotification.type = this.messageService.notificationTypes.ALERT;
                        this.newNotification.message = `Unrecognized event!`;
                        this.iotAccessService.emitter.next(this.newNotification);
                }
            } catch (e) {
                console.error('iot handler service failure: ', e);
            }

        };
    }

}

/* istanbul ignore next */



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/shared/services/iot-handler.service.ts